var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3WhiteLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 151,
    viewBox: "0 0 161 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2773 147.378L2.25531 98.5829M129.066 113.163L75.1069 59.2845M157.289 74.8872L117.99 2.03563",
    stroke: "white",
    strokeWidth: 6.49217
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3WhiteLines);
export default __webpack_public_path__ + "static/media/3-white-lines.09ef3a69eb6b76e2a373b052b8c47a9c.svg";
export { ForwardRef as ReactComponent };